__turbopack_context__.v({
  "accentMainText": "C2gd5q_accentMainText",
  "accentText": "C2gd5q_accentText",
  "backgroundContainer": "C2gd5q_backgroundContainer",
  "backgroundDots": "C2gd5q_backgroundDots",
  "body": "C2gd5q_body",
  "button": "C2gd5q_button",
  "checkbox": "C2gd5q_checkbox",
  "checkboxLabel": "C2gd5q_checkboxLabel",
  "container": "C2gd5q_container",
  "description": "C2gd5q_description",
  "dot": "C2gd5q_dot",
  "form": "C2gd5q_form",
  "formTitle": "C2gd5q_formTitle",
  "header": "C2gd5q_header",
  "input": "C2gd5q_input",
  "logo": "C2gd5q_logo",
  "row": "C2gd5q_row",
  "title": "C2gd5q_title",
});
